// extracted by mini-css-extract-plugin
export default {"bodyDesktop":"styles_bodyDesktop__KzLDU","clickable":"styles_clickable__FA6a+"};